import { useState } from 'react';
import { Button, TextField } from '@radix-ui/themes';
import { call } from 'api';
import { mapValueRank } from 'helpers/ranks';
import { errorToastMessage } from 'helpers/toaster';

export const DrawBestLoserRankingModifyBox = ({ id, bestLoserRanking }: { id?: string; bestLoserRanking: number }) => {
  const [open, setOpen] = useState(false);
  const [bestLoserRankingDraw, setBestLoserRankingDraw] = useState<string>(mapValueRank[bestLoserRanking]);
  const saveFn = () => {
    call(
      `draws/${id}/change-best-loser-ranking`,
      { method: 'PUT', body: JSON.stringify({ best_loser_ranking: bestLoserRankingDraw }) },
      () => {
        window.location.reload();
      },
      (error) => {
        errorToastMessage(JSON.stringify(error));
      },
    );
    setOpen(false);
  };
  return open ? (
    <>
      <TextField.Root
        type='text'
        value={bestLoserRankingDraw}
        onChange={(e) => {
          setBestLoserRankingDraw(e.target.value);
        }}
      />
      <div className='m-5 flex flex-row justify-center'>
        <Button className='cursor-pointer' onClick={saveFn}>
          Salva
        </Button>
        <Button className='ml-5 cursor-pointer' onClick={() => setOpen(false)}>
          Annulla
        </Button>
      </div>
    </>
  ) : (
    <Button className='mb-5 cursor-pointer' onClick={() => setOpen(true)}>
      Modifica Ranking Vincitore
    </Button>
  );
};
export default DrawBestLoserRankingModifyBox;
